module.exports = __webpack_public_path__ + "img/ears-03.ae930166.svg";